import styled from "styled-components";

export const Wrapper = styled.div`
	width: ${(props) => (props.desktop ? "100%" : "300px")};
	border: 1px solid #e6e6e6;
	display: flex;
	justify-content: ${(props) => (props.desktop ? "space-between" : "center")};
	flex-direction: ${(props) => (props.desktop ? "row" : "column")};
	align-items: center;
	border-left: ${(props) =>
		props.desktop ? "8px solid #a157b0" : "1px solid #e6e6e6"};
	padding: 8px;
	border-radius: 8px;
	height: ${(props) => (props.desktop ? "100px" : "auto")};
	.date {
		font-weight: 700;
	}
	.info-text-container {
		margin-left: ${(props) => (props.desktop ? "8px" : "0")};
	}
	.info-buttons-container {
		display: ${(props) => (props.desktop ? "block" : "flex")};
		flex-direction: column;
		justify-content: ${(props) => (props.desktop ? "center" : "center")};
		align-items: ${(props) => (props.desktop ? "center" : "center")};
	}
`;
